/* eslint-disable react/no-array-index-key */
import React from 'react';
import I18n from 'i18n-js';
import { SolicitudPendiente } from 'types/models/SolicitudesPendientesNuevoOnboarding';
import { SectionTitle } from 'components';
import { InscritosModel } from 'types/models/inscritos';
import { FormGroup, FormGroupProps } from 'core';
import { FORMGROUP_TYPES } from 'core/form/FormGroup/FormGroup';
import styles from './datos-factura.module.scss'; // ajusta si lo mueves

interface DatosFacturasProps {
  vieneDeInscritos: boolean;
  inscrito: InscritosModel | undefined;
  solicitudesPendientes: SolicitudPendiente | undefined;
  handleChange: (path: string, value: any) => void;
}
const MAX_MARGENES = 0.3;

const DatosFacturas = ({ vieneDeInscritos, inscrito, solicitudesPendientes, handleChange }: DatosFacturasProps) => {
  const formFieldsComercializador: Array<FormGroupProps> = [
    {
      label: I18n.t('InscritosDetalle.comercializadorAsociado'),
      type: 'string',
      id: vieneDeInscritos ? 'codigoComercializadora' : 'codigo_comercializadora',
      path: vieneDeInscritos ? 'codigoComercializadora' : 'codigo_comercializadora',
      name: vieneDeInscritos ? 'codigoComercializadora' : 'codigo_comercializadora',
      readOnly: !vieneDeInscritos,
      value: vieneDeInscritos ? inscrito?.codigoComercializadora : solicitudesPendientes?.codigo_comercializadora,
    },
  ];

  const formFieldsRightFactura: Array<FormGroupProps> = [
    {
      label: 'P 1',
      type: 'number',
      placeholder: '0',
      id: 'potenciaContratadaP1',
      path: 'potenciaContratadaP1',
      name: 'potenciaContratadaP1',
      value: vieneDeInscritos ? inscrito?.potenciaContratadaP1 : solicitudesPendientes?.potencia_contratada_p1,
      readOnly: !vieneDeInscritos,
    },
    {
      label: 'P 2',
      type: 'number',
      placeholder: '0',
      id: 'potenciaContratadaP2',
      path: 'potenciaContratadaP2',
      name: 'potenciaContratadaP2',
      value: vieneDeInscritos
        ? inscrito?.potenciaContratadaP2
        : (solicitudesPendientes?.potencia_contratada_p2 as number),
      readOnly: !vieneDeInscritos,
    },
    {
      label: 'P 3',
      type: 'number',
      placeholder: '0',
      id: 'potenciaContratadaP3',
      path: 'potenciaContratadaP3',
      name: 'potenciaContratadaP3',
      value: vieneDeInscritos ? inscrito?.potenciaContratadaP3 : solicitudesPendientes?.potencia_contratada_p3,
      readOnly: !vieneDeInscritos,
    },
  ];

  const formFieldsMargenes: Array<FormGroupProps> = [
    {
      label: I18n.t('UpdateTarifaPage.margeMensual'),
      type: 'margenes',
      placeholder: '0',
      id: 'margenMensual',
      path: 'margenMensual',
      name: 'margenMensual',
      readOnly: !vieneDeInscritos,
      value: vieneDeInscritos ? inscrito?.margenMensual : solicitudesPendientes?.margen_mensual,
    },
    {
      label: I18n.t('UpdateTarifaPage.margeKw'),
      type: 'margenes',
      placeholder: '',
      id: 'margenKwH',
      path: 'margenKwH',
      name: 'margenKwH',
      value: vieneDeInscritos ? inscrito?.margenKwH : solicitudesPendientes?.margen_kwh,
      max: MAX_MARGENES,
      readOnly: !vieneDeInscritos,
    },
  ];
  const tarifaDefault: Array<FormGroupProps> = [
    {
      label: 'P 1',
      type: 'number',
      placeholder: '0',
      id: 'Tarifa1',
      path: 'terminoEnergiaP1',
      name: 'Tarifa1',
      value: vieneDeInscritos ? inscrito?.terminoEnergiaP1 : solicitudesPendientes?.termino_energia_p1,
      readOnly: !vieneDeInscritos,
    },

    {
      label: 'P 2',
      type: 'number',
      placeholder: '0',
      id: 'Tarifa2',
      path: 'terminoEnergiaP2',
      name: 'Tarifa2',
      value: vieneDeInscritos ? inscrito?.terminoEnergiaP2 : solicitudesPendientes?.termino_energia_p2,
      readOnly: !vieneDeInscritos,
    },
    {
      label: 'P 3',
      type: 'number',
      placeholder: '0',
      id: 'Tarifa3',
      path: 'terminoEnergiaP3',
      name: 'Tarifa3',
      value: vieneDeInscritos ? inscrito?.terminoEnergiaP3 : solicitudesPendientes?.termino_energia_p3,
      readOnly: !vieneDeInscritos,
    },
  ];
  const potenciaIndustrial: Array<FormGroupProps> = [
    {
      label: 'P 4',
      type: 'number',
      placeholder: '0',
      id: 'potenciaContratadaP4',
      path: 'potenciaContratadaP4',
      name: 'potenciaContratadaP4',
      value: vieneDeInscritos ? inscrito?.potenciaContratadaP4 : solicitudesPendientes?.potencia_contratada_p4,
      readOnly: !vieneDeInscritos,
    },
    {
      label: 'P 5',
      type: 'number',
      placeholder: '0',
      id: 'potenciaContratadaP5',
      path: 'potenciaContratadaP5',
      name: 'potenciaContratadaP5',
      value: vieneDeInscritos ? inscrito?.potenciaContratadaP5 : solicitudesPendientes?.potencia_contratada_p5,
      readOnly: !vieneDeInscritos,
    },
    {
      label: 'P 6',
      type: 'number',
      placeholder: '0',
      id: 'potenciaContratadaP6',
      path: 'potenciaContratadaP6',
      name: 'potenciaContratadaP6',
      value: vieneDeInscritos ? inscrito?.potenciaContratadaP6 : solicitudesPendientes?.potencia_contratada_p6,
      readOnly: !vieneDeInscritos,
    },
  ];
  const tarifaIndustrial: Array<FormGroupProps> = [
    {
      label: 'P 4',
      type: 'number',
      placeholder: '0',
      id: 'Tarifa4',
      path: 'terminoEnergiaP4',
      name: 'Tarifa4',
      value: vieneDeInscritos ? inscrito?.terminoEnergiaP4 : solicitudesPendientes?.termino_energia_p4,
      readOnly: !vieneDeInscritos,
    },

    {
      label: 'P 5',
      type: 'number',
      placeholder: '0',
      id: 'Tarifa5',
      path: 'terminoEnergiaP5',
      name: 'Tarifa5',
      value: vieneDeInscritos ? inscrito?.terminoEnergiaP5 : solicitudesPendientes?.termino_energia_p5,
      readOnly: !vieneDeInscritos,
    },
    {
      label: 'P 6',
      type: 'number',
      placeholder: '0',
      id: 'Tarifa6',
      path: 'terminoEnergiaP6',
      name: 'Tarifa6',
      value: vieneDeInscritos ? inscrito?.terminoEnergiaP6 : solicitudesPendientes?.termino_energia_p6,
      readOnly: !vieneDeInscritos,
    },
  ];

  const arrayForcheckox: Array<FormGroupProps> = [
    {
      label: I18n.t('InscritosDetalle.tipoConsumo'),

      type: FORMGROUP_TYPES.select,
      id: 'tipoConsumo',
      path: 'tipoConsumo',
      name: 'tipoConsumo',
      placeholder: 'wwww',
      value: vieneDeInscritos ? inscrito?.tipoConsumo : solicitudesPendientes?.tipo_consumo,
      disabled: !vieneDeInscritos,
      options: [
        { label: 'Domesticos', value: 'domestico' },
        { label: 'Industrial', value: 'industrial' },
      ],
    },
    {
      label: I18n.t('InscritosDetalle.tipoTarifa'),

      type: FORMGROUP_TYPES.select,
      id: 'tarifa',
      path: 'tarifa',
      name: 'tarifa',
      disabled: !vieneDeInscritos,
      value: vieneDeInscritos ? inscrito?.tarifa : solicitudesPendientes?.tarifa,
      options: [
        { label: 'tarifa1', value: '2.0TD' },
        { label: 'tarifa2', value: '3.0TD' },
        { label: 'Otros', value: 'otros' },
      ],
    },
  ];
  const formprecioCompensacion: Array<FormGroupProps> = [
    {
      label: I18n.t('InscritosDetalle.precioCompensacion'),
      type: 'number',
      placeholder: '0',
      id: 'precioCompensacion',
      path: 'precioCompensacion',
      name: 'precioCompensacion',
      value: vieneDeInscritos ? inscrito?.precioCompensacion : solicitudesPendientes?.precio_compensacion,
      readOnly: !vieneDeInscritos,
    },
  ];
  const formFieldsRightFacturaCheckbox: Array<FormGroupProps> = [
    {
      label: I18n.t('tarifaIndexada'),
      type: 'checkbox',
      id: 'tarifaPVPC',
      path: 'tarifaPVPC',
      name: 'tarifaPVPC',
      checked: vieneDeInscritos ? inscrito?.tarifaPVPC === 'si' : solicitudesPendientes?.tarifa_PVPC,
      value: vieneDeInscritos ? inscrito?.tarifaPVPC === 'si' : solicitudesPendientes?.tarifa_PVPC,
      readOnly: !vieneDeInscritos,
    },
  ];

  return (
    <>
      <div className={styles.flex} style={{ padding: '15px 0px  0px  0px' }}>
        <SectionTitle text={I18n.t('Dades factura')} className={styles.SectionPotencias} />
      </div>

      <div>
        <SectionTitle text={I18n.t('Datos de consumo')} className={styles.SectionTarfa} />
        <div className={styles.containerDatosConsumo}>
          {arrayForcheckox.map((formGroup: FormGroupProps) => (
            <FormGroup
              key={formGroup.id}
              label={formGroup.label}
              type={formGroup.type}
              id={formGroup.id}
              path={formGroup.path}
              name={formGroup.name}
              placeholder={formGroup.placeholder}
              value={formGroup.value}
              required={formGroup.required}
              options={formGroup.options}
              disabled={formGroup.disabled}
              onChange={handleChange}
            />
          ))}
        </div>
        <div className={styles.containerDatosConsumo} style={{ marginTop: '20px' }}>
          {formFieldsComercializador.map((formGroup: FormGroupProps) => (
            <FormGroup
              key={formGroup.id}
              label={formGroup.label}
              type={formGroup.type}
              id={formGroup.id}
              path={formGroup.path}
              name={formGroup.name}
              placeholder={formGroup.placeholder || ''}
              value={formGroup.value}
              required={formGroup.required}
              readOnly={formGroup.readOnly}
              disabled={formGroup.readOnly}
              className={formGroup.className}
              maxLenght={200}
              onChange={handleChange}
            />
          ))}
        </div>
      </div>
      <div className={styles.containerFormsTest}>
        <div className={styles.containerFormsTest1}>
          <div>
            <SectionTitle text={I18n.t('Potencias')} className={styles.SectionTarfa} />
            <div className={styles.containerPotencia}>
              {formFieldsRightFactura.map((formGroup: FormGroupProps) => (
                <FormGroup
                  key={formGroup.id}
                  label={formGroup.label}
                  type={formGroup.type}
                  id={formGroup.id}
                  path={formGroup.path}
                  name={formGroup.name}
                  placeholder={formGroup.placeholder}
                  value={formGroup.value}
                  required={formGroup.required}
                  readOnly={formGroup.readOnly}
                  className={formGroup.className}
                  maxLenght={200}
                  onChange={handleChange}
                />
              ))}

              {solicitudesPendientes?.tipo_consumo === 'industrial' || inscrito?.tipoConsumo === 'industrial'
                ? potenciaIndustrial.map((formGroup: FormGroupProps) => (
                    <FormGroup
                      key={formGroup.id}
                      label={formGroup.label}
                      type={formGroup.type}
                      id={formGroup.id}
                      path={formGroup.path}
                      name={formGroup.name}
                      placeholder={formGroup.placeholder}
                      value={formGroup.value}
                      required={formGroup.required}
                      readOnly={formGroup.readOnly}
                      className={formGroup.className}
                      maxLenght={200}
                      onChange={handleChange}
                    />
                  ))
                : null}
            </div>
          </div>

          <div>
            <SectionTitle text={I18n.t('Tarifa')} className={styles.SectionTarfa} />
            <div className={styles.containerPotencia}>
              {tarifaDefault.map((formGroup: FormGroupProps) => (
                <FormGroup
                  key={formGroup.id}
                  label={formGroup.label}
                  type={formGroup.type}
                  id={formGroup.id}
                  path={formGroup.path}
                  name={formGroup.name}
                  placeholder={formGroup.placeholder}
                  value={formGroup.value}
                  required={formGroup.required}
                  readOnly={formGroup.readOnly}
                  className={formGroup.className}
                  maxLenght={200}
                  onChange={handleChange}
                />
              ))}
              {solicitudesPendientes?.tipo_consumo === 'industrial' || inscrito?.tipoConsumo === 'industrial'
                ? tarifaIndustrial.map((formGroup: FormGroupProps) => (
                    <FormGroup
                      key={formGroup.id}
                      label={formGroup.label}
                      type={formGroup.type}
                      id={formGroup.id}
                      path={formGroup.path}
                      name={formGroup.name}
                      placeholder={formGroup.placeholder}
                      value={formGroup.value}
                      required={formGroup.required}
                      readOnly={formGroup.readOnly}
                      className={formGroup.className}
                      maxLenght={200}
                      onChange={handleChange}
                    />
                  ))
                : null}
            </div>
          </div>
          <div className={styles.containerPotenciapRECIO}>
            {formprecioCompensacion.map((formGroup: FormGroupProps) => (
              <FormGroup
                key={formGroup.id}
                label={formGroup.label}
                type={formGroup.type}
                id={formGroup.id}
                path={formGroup.path}
                name={formGroup.name}
                placeholder={formGroup.placeholder}
                value={formGroup.value}
                required={formGroup.required}
                readOnly={formGroup.readOnly}
                className={formGroup.className}
                onChange={handleChange}
                maxLenght={200}
              />
            ))}
          </div>

          <div className={styles.MargenTopCheckbox}>
            {formFieldsRightFacturaCheckbox.map((formGroup: FormGroupProps) => (
              <FormGroup
                key={formGroup.id}
                label={formGroup.label}
                type={formGroup.type}
                id={formGroup.id}
                path={formGroup.path}
                name={formGroup.name}
                placeholder={formGroup.placeholder}
                value={formGroup.value}
                required={formGroup.required}
                readOnly={formGroup.readOnly}
                className={formGroup.className}
                checked={formGroup.checked}
                onChange={handleChange}
                maxLenght={200}
              />
            ))}
          </div>

          {solicitudesPendientes?.tarifa_PVPC ? (
            <div>
              <SectionTitle text={I18n.t('UpdateTarifaPage.margenesTecnico')} className={styles.SectionTarfa} />
              <div className={styles.containerMargenes}>
                {formFieldsMargenes.map((formGroup: FormGroupProps) => (
                  <FormGroup
                    key={formGroup.id}
                    label={formGroup.label}
                    type={formGroup.type}
                    id={formGroup.id}
                    path={formGroup.path}
                    name={formGroup.name}
                    placeholder={formGroup.placeholder}
                    value={formGroup.value}
                    required={formGroup.required}
                    readOnly={formGroup.readOnly}
                    className={formGroup.className}
                    maxLenght={200}
                    step={0.01}
                    min={formGroup.min}
                    max={formGroup.max}
                    onChange={handleChange}
                  />
                ))}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </>
  );
};

export default DatosFacturas;
